import { StyleSheet } from "react-native";
import Colors from "../Color/Colors";
import { globalFontStyle } from "../Font/FontFamily";
import {globalConfigurableData} from "../../utils/globalConstant";

export const globalFormStyle = StyleSheet.create({
  fieldLeft: {
    color: globalConfigurableData.secondaryTextColor1,
    ...globalFontStyle.appFontBody,
  },
  fieldLeft1: {
    color: globalConfigurableData.primaryTextColor1,
    ...globalFontStyle.appFontSmallText,
  },
  fieldRight: {
    color: globalConfigurableData.secondaryTextColor1,
    ...globalFontStyle.appFontBody,
  },
  fieldBlue: {
    color: Colors.tradexBlue,
    ...globalFontStyle.appFontBody,
  },
  tableContainerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
    paddingVertical: 15,
    alignItems: "center",
  },
  formTopHeader: {
    backgroundColor: Colors.tradexBlue1,
    padding: 18,
  },
  formTopHeaderText: {
    ...globalFontStyle.appFontHeading,
    color: Colors.tradexBlue,
  },
  tableContainerRowNewForm: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
    paddingVertical: 5,
    alignItems: "center",
  },
});
